import pubsub from "../../pubsub";
import {TBaseOrObservableType} from "../../index";
import {nsModal} from "./fn";
import {TComponentName} from "../../constants/ComponentRegistry";
import formatTitle = nsModal.formatTitle;
import componentHtml from './component.html?raw';

export let template: string = componentHtml;

export interface IComponentDialogParams {
    dialog: IDialog,
    component: {
        name: TComponentName
        params: {
            dialog: IDialog
        } & any
    }
}

export interface IDialog {
    title: TBaseOrObservableType<string>
    closeable: KnockoutObservable<boolean>
    cls?: string
}

export class viewModel {

    dialogData: KnockoutObservable<IComponentDialogParams>;

    private $el: JQuery<Element>;

    constructor(params: { dialogData: KnockoutObservable<IComponentDialogParams> }) {
        this.$el = jQuery('#modalComponentDialog');
        
        this.$el.on(<any>"hide.bs.modal", (e: Event) => {
            if (!this.dialogData()?.dialog.closeable?.()) {
                e.preventDefault();
            } else {
                pubsub.trigger("before.close.dialog", this.dialogData());
            }
        });
        
        this.dialogData = params.dialogData;

        this.dialogData.subscribe(() => {
            this.$el.modal("show");
        });

        window.addEventListener("popstate", (e: PopStateEvent) => {
            this.onCloseClick();
        }, true);
        
        pubsub.on(this, "close.dialog", (e: any, dialogData: IDialog) => {
            if (this.dialogData().dialog == dialogData) {
                this.dialogData().dialog.closeable(true);
                this.$el.modal("hide");
            }
        })

    }

    onCloseClick() {
        pubsub.trigger("before.close.dialog", this.dialogData());
        this.$el.modal("hide");
    }

    private getDialogTitle() {
        return formatTitle(this.dialogData().dialog.title);
    }

    dispose() {
        pubsub.off(this);
    }

}
